import { Dispatch, FC, SetStateAction, useState } from 'react'
import { LoginButton, useFacebook, useLogin } from 'react-facebook'
import { Modal, Radio } from 'antd'
import { BtnAnch } from 'components/elements/global'
import { TIntegrationItem } from '../types'

export const AddNewIntegrationModal: FC<{
 OnCancel?: () => void
 show?: boolean
 intItems: TIntegrationItem[]
 setIntItems: Dispatch<SetStateAction<TIntegrationItem[]>>
}> = ({ intItems, setIntItems, OnCancel, show }) => {
 const { init } = useFacebook()
 const [selectedValue, setSelectedValue] = useState<'yes' | 'no'>('no')
 //  const { onboarding_settings } = useWebSettings()
 //  const { onBoardListingStatus } = onboarding_settings || {}
 //  const d = useAppDispatch()

 const containsItem = (item: any) => {
  for (let i = 0; i < intItems?.length; i++) {
   if (intItems?.[i].page_id === `${item.id}`) {
    return true
   }
  }
  return false
 }

 const { login } = useLogin()

 const refetch = async () => {
  Modal?.destroyAll()
  const response = await login({
   scope:
    'pages_read_engagement,leads_retrieval,pages_manage_metadata,pages_show_list,pages_manage_ads,ads_management,business_management',
  })
  handleSuccess(response, false)
 }

 const handleSuccess = async (res?: any, firstTry?: boolean) => {
  const api = await init()
  const FB = await api?.getFB()
  if (res?.status === 'connected') {
   FB.api('/me/accounts', (accRes: any) => {
    if ((accRes?.data?.length === 0 || !accRes?.data) && firstTry) {
     Modal.confirm({
      className: 'mts-confirm',
      title: 'Something Went Wrong!',
      icon: (
       <div className="con-icon-block">
        <i className="far fa-exclamation-triangle" />
       </div>
      ),
      okButtonProps: {
       style: { display: 'none' },
      },
      content: (
       <p>
        Connection request failed! Please{' '}
        <BtnAnch className="colored-link-1" onClick={() => refetch()}>
         Click Here
        </BtnAnch>{' '}
        to resend the request.
       </p>
      ),
     })
    } else {
     //  if (!onBoardListingStatus?.facebook_integration) {
     //   d(baseAPI.util.invalidateTags(['WEB-SETTINGS']))
     //  }

     for (let j = 0; j < accRes?.data?.length; j++) {
      if (!containsItem(accRes?.data?.[j])) {
       const { access_token, id, name } = accRes?.data?.[j] || {}
       setIntItems((prv) => [
        ...prv,
        {
         page_access_token: access_token,
         page_id: id,
         page_name: name,
         status: 'Activate',
         import_lead: selectedValue === 'yes',
        },
       ])
      }
     }
     OnCancel?.()
    }
   })
  }
 }
 return (
  <Modal footer={null} onCancel={OnCancel} visible={show}>
   {/* Hekki */}
   <div className="add-new-integration-modal">
    <h1>Integrate Your FB Pages</h1>
    <p>
     Do you want to import the existing leads in your pages after successful
     integration?
    </p>
    <Radio.Group
     onChange={(e) => setSelectedValue(e.target.value)}
     value={selectedValue}
     className="add-new-radio-group"
    >
     <Radio value="yes">Yes</Radio>
     <Radio value="no">No</Radio>
    </Radio.Group>
    <div className="fb-login-btn">
     <LoginButton
      scope="pages_read_engagement,leads_retrieval,pages_manage_metadata,pages_show_list,pages_manage_ads,ads_management"
      onError={(err) => console.log(err)}
      onSuccess={(res) => handleSuccess?.(res, true)}
      reauthorize
     >
      Continue
     </LoginButton>
    </div>
    <div className="add-new-integration-notes">
     <span>Note:</span> If you don’t want to import the leads now, you can do it
     later by manually importing the same from the Lead Listings page.
    </div>
   </div>
  </Modal>
 )

 //  return (
 //   <div className="fb-login-btn">

 //   </div>
 //  )
}
